import React, { useCallback, useState } from 'react';
import AppstreamStatus from '../appstream-status/appstream-status';

function Application() {
  const [loading, setLoading] = useState(false);
  const [full, setFull] = useState(false);
  const [err, setErr] = useState(null);

  const handleAppstreamClick = useCallback(async () => {
    if (loading) return; // prevent double clicks
    setLoading(true);
    setFull(false);

    try {
      const res = await fetch(process.env.REACT_APP_FACES_API_BASE + "/get-seat", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem('facesIDToken')}` }
      });
      if (!res.ok) {
        if(res.status === 409) {
          setFull(true)
        } else {
          setErr(res.status);
          throw new Error(`HTTP ${res.status}`);
        }
      }

      const data = await res.json(); // e.g. { url: "https://..." }
      const url = data.streaming_url;
      if (!url) throw new Error('No URL returned from server');

      // Redirect (same tab). Use window.open(url, "_blank") for new tab.
      window.location.assign(url);
    } catch (e) {
      setErr(e.message || 'Failed to get AppStream URL');
    } finally {
      setLoading(false);
    }
  }, [loading]);

  return <AppstreamStatus onAppstreamClick={ handleAppstreamClick } err={err} isReady={!full} />;
}

export default Application;
